import client from './client';
import { 
  ApiResponse, 
  LoginRequest, 
  SignupRequest,
  TokenResponse, 
  MeResponse, 
  IntrospectRequest,
  IntrospectResponse,
  ServiceApplicationResponse,
  ServiceApplicationStatus,
  ServiceResponse,
  AuditLogResponse,
  PageResponse,
} from '../types';

export const authApi = {
  login: (data: LoginRequest) => 
    client.post<ApiResponse<TokenResponse>>('/api/v1/auth/login', data),

  signup: (data: SignupRequest) =>
    client.post<ApiResponse<TokenResponse>>('/api/v1/auth/signup', data),
    
  logout: (data?: { refreshToken?: string }) => 
    client.post<ApiResponse<void>>('/api/v1/auth/logout', data || {}),
    
  reissue: (data?: { refreshToken?: string }) =>
    client.post<ApiResponse<{ accessToken: string; refreshToken: string }>>('/api/v1/auth/reissue', data || {}),

  getMe: () => 
    client.get<ApiResponse<MeResponse>>('/api/v1/auth/me'),
    
  changePassword: (data: { password: string }) => 
    client.patch<ApiResponse<void>>('/api/v1/auth/me/password', data),
    
  introspect: (data: IntrospectRequest) => 
    client.post<ApiResponse<IntrospectResponse>>('/api/v1/auth/introspect', data),

  requestPasswordReset: (data: { email: string }) =>
    client.post<ApiResponse<{ expiresInSeconds: number }>>('/api/v1/auth/password-reset/request', data),

  validatePasswordResetCode: (data: { email: string; code: string }) =>
    client.post<ApiResponse<{ valid: boolean; expired: boolean; revoked: boolean }>>('/api/v1/auth/password-reset/validate', data),

  confirmPasswordReset: (data: { email: string; code: string; password: string }) =>
    client.post<ApiResponse<void>>('/api/v1/auth/password-reset/confirm', data),

  submitServiceApplication: (data: { serviceCode: string }) =>
    client.post<ApiResponse<ServiceApplicationResponse>>('/api/v1/auth/service-applications', data),

  getServiceApplicationCatalog: () =>
    client.get<ApiResponse<ServiceResponse[]>>('/api/v1/auth/service-applications/catalog'),

  getMyServiceApplications: () =>
    client.get<ApiResponse<ServiceApplicationResponse[]>>('/api/v1/auth/service-applications/me'),

  getServiceApplications: () =>
    client.get<ApiResponse<ServiceApplicationResponse[]>>('/api/v1/admin/service-applications'),

  updateServiceApplication: (applicationId: number, data: { status: ServiceApplicationStatus }) =>
    client.patch<ApiResponse<ServiceApplicationResponse>>(`/api/v1/admin/service-applications/${applicationId}`, data),

  getAuditLogs: (params?: {
    actorName?: string;
    actorEmail?: string;
    keyword?: string;
    userId?: number;
    targetId?: number;
    serviceCode?: string;
    action?: string;
    from?: string;
    to?: string;
    page?: number;
    size?: number;
  }) =>
    client.get<ApiResponse<PageResponse<AuditLogResponse>>>('/api/v1/admin/audit-logs', { params }),
};
